import React from 'react';
import TeamAssignmentModal from './TeamAssignmentModal';

/**
 * "This is a battle" checkbox + format section + TeamAssignmentModal.
 * Shared presentational piece driven by useBattleDesignation, so every form
 * that lets an admin designate a battle (AdminDashboard VideoModal,
 * VideoUpload) renders and behaves identically.
 *
 * @param {object} formData
 * @param {object} battle the object returned by useBattleDesignation(...)
 */
const BattleDesignationFields = ({ formData, battle }) => {
  const {
    showTeamModal,
    setShowTeamModal,
    battleArtistCount,
    handleBattleToggle,
    selectedBattleArtists,
    handleTeamsConfirmed,
  } = battle;

  return (
    <>
      <div className="border border-army/20 rounded-lg p-3">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={!!formData.is_battle}
            onChange={handleBattleToggle}
            className="form-checkbox text-brand-yellow"
            data-testid="is-battle-checkbox"
          />
          <span className="text-white font-semibold text-sm">This is a battle</span>
        </label>

        {formData.is_battle && (
          <div className="mt-3 pl-6" data-testid="battle-format-section">
            {battleArtistCount === 2 && (
              <p className="text-gray-400 text-sm" data-testid="battle-format-1v1">
                Format: <span className="text-brand-yellow font-bold">1v1</span> — sides
                assigned in the order artists were selected.
              </p>
            )}

            {battleArtistCount === 4 && (
              <div>
                {formData.battle_format === '2v2' && formData.sides ? (
                  <p className="text-gray-400 text-sm" data-testid="battle-format-2v2">
                    Format: <span className="text-brand-yellow font-bold">2v2</span> — teams
                    assigned.{' '}
                    <button
                      type="button"
                      onClick={() => setShowTeamModal(true)}
                      className="text-blue-400 hover:text-blue-300 underline"
                      data-testid="edit-teams-btn"
                    >
                      Edit teams
                    </button>
                  </p>
                ) : (
                  <button
                    type="button"
                    onClick={() => setShowTeamModal(true)}
                    className="btn-secondary text-sm"
                    data-testid="assign-teams-btn"
                  >
                    Assign 2v2 Teams
                  </button>
                )}
              </div>
            )}

            {battleArtistCount !== 2 && battleArtistCount !== 4 && (
              <p className="text-red-400 text-sm" data-testid="battle-count-error">
                A battle needs exactly 2 artists (1v1) or exactly 4 artists (2v2). Currently
                selected: {battleArtistCount}.
              </p>
            )}
          </div>
        )}
      </div>

      <TeamAssignmentModal
        show={showTeamModal}
        artists={selectedBattleArtists}
        initialSides={formData.sides}
        onConfirm={handleTeamsConfirmed}
        onCancel={() => setShowTeamModal(false)}
      />
    </>
  );
};

export default BattleDesignationFields;
